import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputFileRootFn = /* @__PURE__ */ createRecipe('input-file-root', {}, [])

const inputFileRootVariantMap = {}

const inputFileRootVariantKeys = Object.keys(inputFileRootVariantMap)

export const inputFileRoot = /* @__PURE__ */ Object.assign(memo(inputFileRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputFileRoot',
  __getCompoundVariantCss__: inputFileRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputFileRootVariantKeys,
  variantMap: inputFileRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputFileRootVariantKeys)
  },
  getVariantProps: inputFileRootFn.getVariantProps,
})